import React from 'react';
import Link, { LinkOwnProps } from '@mui/material/Link';
import { fontWeight } from '@tphglobal/common/theme/style.typography';

interface LinkProps extends Omit<LinkOwnProps, 'variant'> {
  href?: string;
  onClick?: () => void;
  variant:
    | 'Fixed18Medium'
    | 'Fixed16Medium'
    | 'Fixed16Regular'
    | 'Fixed14Bold'
    | 'Fixed14Medium'
    | 'Fixed14Regular'
    | 'Fixed12Bold'
    | 'Fixed12Medium'
    | 'Fixed12Regular'
    | 'Fixed11Regular'
    | 'Fixed10Regular'
    | 'Fixed18Bold'
    | 'Fixed18Regular'
    | 'Fixed16Bold'
    | 'Fixed14RegularTight'
    | 'Fixed12Light'
    | 'Fixed10Bold'
    | 'Fixed10Medium';
  label: string;
  target?: string;
  color?: string;
  hoverColor?: string;
  component?: React.ElementType;
}

const variantStyles: Record<string, any> = {
  Fixed18Medium: {
    fontSize: '18px',
    fontWeight: fontWeight.medium,
    lineHeight: '23px',
  },
  Fixed18Bold: {
    fontSize: '18px',
    fontWeight: fontWeight.bold,
    lineHeight: '23px',
  },
  Fixed18Regular: {
    fontSize: '18px',
    fontWeight: fontWeight.regular,
    lineHeight: '23px',
  },
  Fixed16Medium: {
    fontSize: '16px',
    fontWeight: fontWeight.medium,
    lineHeight: '21px',
  },
  Fixed16Bold: {
    fontSize: '16px',
    fontWeight: fontWeight.bold,
    lineHeight: '21px',
  },
  Fixed16Regular: {
    fontSize: '16px',
    fontWeight: fontWeight.regular,
    lineHeight: '21px',
  },
  Fixed14Bold: {
    fontSize: '14px',
    fontWeight: fontWeight.bold,
    lineHeight: '18px',
  },
  Fixed14Medium: {
    fontSize: '14px',
    fontWeight: fontWeight.medium,
    lineHeight: '18px',
  },
  Fixed14Regular: {
    fontSize: '14px',
    fontWeight: fontWeight.regular,
    lineHeight: '18px',
  },
  Fixed14RegularTight: {
    fontSize: '14px',
    fontWeight: fontWeight.regular,
    lineHeight: '16px',
  },
  Fixed12Bold: {
    fontSize: '12px',
    fontWeight: fontWeight.bold,
    lineHeight: '16px',
  },
  Fixed12Medium: {
    fontSize: '12px',
    fontWeight: fontWeight.medium,
    lineHeight: '16px',
  },
  Fixed12Regular: {
    fontSize: '12px',
    fontWeight: fontWeight.regular,
    lineHeight: '16px',
  },
  Fixed12Light: {
    fontSize: '12px',
    fontWeight: fontWeight.light,
    lineHeight: '16px',
  },
  Fixed11Regular: {
    fontSize: '11px',
    fontWeight: fontWeight.regular,
    lineHeight: '14px',
  },
  Fixed10Bold: {
    fontSize: '10px',
    fontWeight: fontWeight.bold,
    lineHeight: '13px',
  },
  Fixed10Medium: {
    fontSize: '10px',
    fontWeight: fontWeight.medium,
    lineHeight: '13px',
  },
  Fixed10Regular: {
    fontSize: '10px',
    fontWeight: fontWeight.regular,
    lineHeight: '13px',
  },
};

const CustomLink: React.FC<LinkProps> = ({
  href,
  onClick,
  target = '_self',
  color = 'inherit',
  hoverColor,
  variant,
  label,
  component = 'a',
  ...props
}) => {
  const sx = {
    ...variantStyles[variant],
    color: color,
    '&:hover': {
      color: hoverColor || color,
      cursor: 'pointer',
    },
  };

  return (
    <Link
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      sx={sx}
      onClick={onClick}
      component={component}
      {...props}
    >
      {label}
    </Link>
  );
};

export default CustomLink;
